var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_7231)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_100_7231",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.431152 0.55127H16.1483V16.2684H0.431152V0.55127Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_100_7231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8084 1.2876H15.2187L9.95349 7.32073L16.1483 15.5318H11.2984L7.49713 10.5528L3.15246 15.5318H0.739882L6.37111 9.07656L0.431152 1.28872H5.4045L8.83533 5.83883L12.8084 1.2876ZM11.9608 14.0858H13.2967L4.67478 2.65836H3.24227L11.9608 14.0858Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_7231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7171,
    height: 15.7171,
    fill: "white",
    transform: "translate(0.431152 0.55127)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.1dfb0fdb9620dc5b0650fe7e53ccb83c.svg";
export { ForwardRef as ReactComponent };